export default {
  name: 'zh-cn',
  sure: {
    icon: 'sure 图标 国际化'
  }
}
